import * as React from 'react'

import { Button } from 'reactstrap'
import Calendar from 'react-calendar'

import TerminationFormData from '../TerminationFormData.interface'
import TerminationFormDataUpdate from '../TerminationFormDataUpdate.type'

export interface TerminationDateProps {
  terminationForm: TerminationFormData
  statusCallback: TerminationFormDataUpdate
}

export interface TerminationDateState {
  lastDayOfWork?: Date
}

class TerminationDate extends React.PureComponent<TerminationDateProps, TerminationDateState> {
  constructor(props) {
    super(props)

    this.state = {
      lastDayOfWork: props.terminationForm.lastDayOfWork
    }
    
    this.updateDateStatus = this.updateDateStatus.bind(this)
  }

  updateDateStatus() {
    const { lastDayOfWork } = this.state
    const { terminationForm } = this.props

    terminationForm.lastDayOfWork = lastDayOfWork
    this.props.statusCallback('TERMINATION_REASON', terminationForm)
  }

  render() {
    const { lastDayOfWork } = this.state
    
    return (
      <div className="p4">
        <div>
          <h5 className="text-justify">Select employee's last day of work.</h5>
          <Calendar value={lastDayOfWork} onChange={(date: Date) => this.setState({ lastDayOfWork: date })} />
        </div>

        {!!lastDayOfWork && (
          <Button color="primary" className="btn-block mt-4" onClick={this.updateDateStatus}>
            Next
          </Button>
        )}
      </div>
    )
  }
}

export default TerminationDate


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationDate.component.tsx